import { z } from 'zod'

/**
 * 產品版本 - 多筆資料 Schema
 */
export const productVersionListDataSchema = z.object({
  /** 版本 */
  version: z.string(),
  /** 是否啟用 */
  isEnable: z.boolean()
})

/**
 * 產品版本 - 多筆資料
 */
export interface ProductVersionListData
  extends z.infer<typeof productVersionListDataSchema> {}
